import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useRef } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Box, TextField, Typography } from 'seagull';
import { DefaultValuePopover } from '~/components/AgreementStudioPage/TemplateVariables/DefaultValuePopover/DefaultValuePopover';
import { useTextFieldVariableIntegration } from '~/components/AgreementStudioPage/TemplateVariables/hooks/useTextFieldVariableIntegration';
import { VariableFieldAdornment } from '~/components/AgreementStudioPage/TemplateVariables/VariableFieldAdornment/VariableFieldAdornment';
import { VariablePickerPopover } from '~/components/VariablePickerPopover/VariablePickerPopover';
import styles from '../AdHocBillModal.module.scss';
export const EmailContentSection = (param)=>{
    let { testIds, texts } = param;
    const { control, setValue } = useFormContext();
    const subjectInputRef = useRef(null);
    const contentInputRef = useRef(null);
    const setSubjectField = useCallback((newValue)=>setValue('emailSubject', newValue), [
        setValue
    ]);
    const setContentField = useCallback((newValue)=>setValue('emailContent', newValue), [
        setValue
    ]);
    const subjectIntegration = useTextFieldVariableIntegration(subjectInputRef, setSubjectField);
    const contentIntegration = useTextFieldVariableIntegration(contentInputRef, setContentField, {
        adornmentStyle: {
            position: 'absolute',
            top: 14,
            right: 14
        }
    });
    return /*#__PURE__*/ _jsxs(Box, {
        className: styles.section,
        testId: testIds.Section(),
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: "paragraph2",
                weight: "normal",
                className: styles.sectionTitle,
                children: texts.sectionTitle()
            }),
            /*#__PURE__*/ _jsx(Controller, {
                control: control,
                name: "emailSubject",
                render: (renderProps)=>/*#__PURE__*/ _jsx(TextField, {
                        bi: {
                            name: 'email_subject'
                        },
                        label: texts.subjectLabel(),
                        testId: testIds.Subject(),
                        value: renderProps.field.value,
                        onChange: renderProps.field.onChange,
                        onBlur: renderProps.field.onBlur,
                        inputRef: (el)=>{
                            subjectInputRef.current = el;
                        },
                        inputProps: subjectIntegration.inputProps,
                        InputProps: subjectIntegration.enabled ? {
                            endAdornment: /*#__PURE__*/ _jsx("span", {
                                ref: subjectIntegration.adornmentRef,
                                style: subjectIntegration.adornmentStyle,
                                children: /*#__PURE__*/ _jsx(VariableFieldAdornment, _object_spread({}, subjectIntegration.fieldAdornmentProps))
                            })
                        } : undefined
                    })
            }),
            /*#__PURE__*/ _jsx(Controller, {
                control: control,
                name: "emailContent",
                render: (renderProps)=>/*#__PURE__*/ _jsx(TextField, {
                        bi: {
                            name: 'email_content'
                        },
                        multiline: true,
                        minRows: 6,
                        className: styles.emailContentField,
                        label: texts.contentLabel(),
                        testId: testIds.Content(),
                        value: renderProps.field.value,
                        onChange: renderProps.field.onChange,
                        onBlur: renderProps.field.onBlur,
                        inputRef: (el)=>{
                            contentInputRef.current = el;
                        },
                        inputProps: contentIntegration.inputProps,
                        InputProps: contentIntegration.enabled ? {
                            endAdornment: /*#__PURE__*/ _jsx("span", {
                                ref: contentIntegration.adornmentRef,
                                style: contentIntegration.adornmentStyle,
                                children: /*#__PURE__*/ _jsx(VariableFieldAdornment, _object_spread({}, contentIntegration.fieldAdornmentProps))
                            })
                        } : undefined
                    })
            }),
            subjectIntegration.enabled && /*#__PURE__*/ _jsx(VariablePickerPopover, _object_spread({}, subjectIntegration.pickerPopoverProps)),
            subjectIntegration.enabled && /*#__PURE__*/ _jsx(DefaultValuePopover, _object_spread({}, subjectIntegration.defaultValuePopoverProps)),
            contentIntegration.enabled && /*#__PURE__*/ _jsx(VariablePickerPopover, _object_spread({}, contentIntegration.pickerPopoverProps)),
            contentIntegration.enabled && /*#__PURE__*/ _jsx(DefaultValuePopover, _object_spread({}, contentIntegration.defaultValuePopoverProps))
        ]
    });
};
